export default __webpack_public_path__ + "static/media/miguel-lopes-10.50703d65.jpg";